import React,{useEffect} from 'react';
import { Button, Col, Container, Form, FormControl, FormGroup, FormLabel, NavLink, Row } from 'react-bootstrap';

import { HeroBg, VideoBg } from '../HeroSection/HeroElements';

import entrance from '../../videos/Entrance.mp4';

import premiumRoom4 from '../../images/hotelroom1.jpg';
import classic3 from '../../images/classic rooms/classic3.jpg';
import comfort1 from '../../images/comfort room/comfort1.jpg';
import economic2 from '../../images/economic room/economic2.jpg';
import Tv from '../../images/42-lcd-tv.png';
import Wifi from '../../images/high-speed-internet.png';
import Maharaja02 from '../../images/maharaja/Maharaja02.jpg';
import TeaMaker from '../../images/tea-coffee-maker.png';
import SaveRoom from '../../images/electronic-in-room-safe.png';
import discount33 from '../../images/discount33.png';
import {CgScreen} from 'react-icons/cg';
import {AiOutlineWifi} from 'react-icons/ai';
import {MdOutlineKingBed} from 'react-icons/md';
import {BsSnow2} from 'react-icons/bs';
import {BiDish, BiWifi} from "react-icons/bi";
import { IoIosArrowForward } from "react-icons/io";
import {IoResizeOutline} from 'react-icons/io5';
import {BiRupee} from 'react-icons/bi';
import {SiNetflix} from 'react-icons/si';
import {SiAmazonprime} from 'react-icons/si';
import {GiDesk} from 'react-icons/gi';
import Aos from "aos";
import "aos/dist/aos.css";
import './Discover.css';
import MobileCard from './MobileCard';
import { useParams } from 'react-router-dom';
import { HashLink as Link } from 'react-router-hash-link';


function DiscoverPage() {


  useEffect(() => {
    window.scroll(0,0)
    Aos.init({duration:2000});
  }, []);


    return (
  <div>
      <section  className='videoTagWrapper'>
          <a href='https://www.youtube.com/watch?v=4g0WRKKKxQI'>
            <video className='videoTag' autoPlay loop muted >
            <source src={entrance} type='video/mp4' />
            </video>
          </a>
      </section>
      <section className='DiscoverBody'>
      
        <section className='formContainer'>
          <Form  className='formDis'>
            <Row className='rowForm'>

                  {/* <Col xl={2} lg={2} md={6} className='CheckInCol'>
                      <FormGroup>
                          <FormLabel>Check-in</FormLabel>
                          <FormControl type='date' required />
                      </FormGroup>
                  </Col>
                  <Col xl={2} lg={2} md={6} className='CheckOutCol'>
                      <FormGroup>
                          <FormLabel>Check-out</FormLabel>
                          <FormControl type='date' required />
                      </FormGroup>
                  </Col>
                   <Col xl={2} lg={2} md={6} sm={6} className='GuestCol'>
                      <FormGroup>
                          <FormLabel>Guest</FormLabel>
                          <Form.Select  required>
                              <option value='' selected hidden>No of rooms </option>
                              <option>1</option>
                              <option>2</option>
                              <option>3</option>
                          </Form.Select>
                      </FormGroup>
                  </Col>
                  <Col xl={2} lg={2} md={6} sm={6} className='ChildCol'>
                    <FormGroup>
                        <FormLabel>Child</FormLabel>
                        <Form.Select  required>
                            <option value='' selected hidden>No of children </option>
                            <option>1</option>
                            <option>2</option>
                            <option>3</option>
                        </Form.Select>
                    </FormGroup>
                </Col> */}
                <Col
                //  xl={4} lg={4}
                  className='AvailabilityCol'>
                  <a href='https://www.secure-booking-engine.com/accounts/FrmOnne118jtpxNpFLSXTA/properties/hahnewYRURcxpWB0cjHizA/booking-engine/web/source/4wsctBw6Oq6j-g9XuxeRzQ/cart/x1gwU9S1r1Hk_KEYUgclHQ/#/search'>
                    <Button className='AvailSubmitBtn'>CHECK ROOMS AVAILABILTY</Button>
                  </a>
                  
                </Col>
            </Row>
          </Form>
        </section>

        <section>
          <div className='welcomeWrapper'>
            <h2 style={{textAlign:'center',paddingBottom:'5px',paddingTop:'20px'}}>ROOMS & SUITES </h2>
            <p style={{textAlign:'justify',fontSize:'17px'}}>
            We aim to provide you with every comfort and convenience you desire and deserve. 
            There are numerous facilities and services catering to meet all your needs and demands 
            for an idyllic stay, and our friendly and expert staff specializes in customizing our multitude 
            of services to suit your exact requirements. Please feel free to contact us in advance to inform us 
            of your needs, or reach out to our reception at any time while staying with us.
            </p>
              
          </div>
        </section>
        <section data-Aos='fade-in' id='classic' className='MovingCard'>
            <div className='room-list-wrapper'>
              <NavLink to=''>
                  <Container  className='image-wrapper'>
                    <Link to='/luxroom'>
                        <img src={classic3} alt='tof' className='img-slide ' />
                    </Link>
                      
                      
                  </Container>
              </NavLink>
              
                  <div className='features-wrapper'>
                      <div className='content-header'>
                        
                        <h3 className='executive-header'>CLASSIC DOUBLE</h3>
                        <p>07 well appointed Classic size Rooms...</p>
                      </div>
                      <div  className='items-wrapper'>
                        <Row>
                          <Col lg={3} md={3} sm={3} xs={3} className='item-feature'>
                            <div className='item-feature-img'>
                              <CgScreen  className='reactIcons' />
                            </div>
                            <div className='item-feature-content'>
                                <span> Smart TV</span>
                            </div>
                          </Col>
                          <Col lg={3} md={3} sm={3} xs={3} className='item-feature'>
                            <div className='item-feature-img'>
                              
                              <BiWifi  className='reactIcons' />
                            </div>
                            <div className='item-feature-content'>
                                <span> High Speed Internet</span>
                            </div>
                          </Col>
                          <Col lg={3} md={3} sm={3} xs={3} className='item-feature'>
                            <div className='item-feature-img'>
                              
                              <BsSnow2  className='reactIcons ' />
                            </div>
                            <div className='item-feature-content'>
                                <span>Air Conditioner</span>
                            </div>
                          </Col>
                          <Col lg={3} md={3} sm={3} xs={3} className='item-feature'>
                            <div className='item-feature-img'>
                              <GiDesk  className='reactIcons' />
                            </div>
                            <div className='item-feature-content'>
                                <span> Office Table</span>
                            </div>
                          </Col>
                        </Row>
                        <Row className='SecondRow'>
                          <Col lg={3} md={3} sm={3} xs={3} className='item-feature'>
                            <div className='item-feature-img'>
                              
                              <MdOutlineKingBed  className='reactIcons' />
                            </div>
                            <div className='item-feature-content'>
                                <span> Queen Size Bed</span>
                            </div>
                          </Col>
                          <Col lg={3} md={3} sm={3} xs={3} className='item-feature'>
                            <div className='item-feature-img'>
                              
                              <BiDish  className='reactIcons' />
                            </div>
                            <div className='item-feature-content'>
                                <span> 24/7 Room Service</span>
                            </div>
                          </Col>
                          <Col lg={3} md={3} sm={3} xs={3} className='item-feature'>
                            <div className='item-feature-img'>
                              
                              <IoResizeOutline  className='reactIcons' />
                            </div>
                            <div className='item-feature-content'>
                                <span>140-180 ft2</span>
                            </div>
                          </Col>
                          
                          
                        </Row>
              
                      </div>
                      <div className='readmoreClass'>
                        <Link  to='/luxroom' style={{fontSize:'13px',color:'#4d3319'}}>READ MORE <IoIosArrowForward style={{verticalAlign:'text-bottom'}} /> </Link>
                      </div>
                      {/* <h6>From</h6> */}
                      <div className='wholeBox'>
                      <div className='priceBox'>
                          <div className='priceRoom'>
                            <h6 style={{marginRight:'10px'}}>From</h6>
                            <span className='lineBar'>
                                <h5><BiRupee />1999 /</h5>
                                <h6>per night*</h6>
                            </span>
                          
                          </div>

                          <div className='priceRoom2'>
                          
                            <h5><BiRupee />1319 /</h5>
                            <h6>per night*</h6>
                            {/* <p style={{color:'red',position:'relative',left:'10px',top:'-3px',fontFamily:'inherit'}}>inclusive of all taxes - GST</p> */}
                          </div>
                          <p style={{color:'red',position:'relative',left:'70px',top:'-3px',fontFamily:'inherit'}}>inclusive of all taxes - GST</p>
                        </div>

                        <div className='bloc-discount'>
                          <img src={discount33} className='discount33' alt='logo' />
                        </div>
                        </div>
                      <div className='bookNow'>
                      <a href='https://www.secure-booking-engine.com/accounts/FrmOnne118jtpxNpFLSXTA/properties/hahnewYRURcxpWB0cjHizA/booking-engine/web/source/4wsctBw6Oq6j-g9XuxeRzQ/cart/Cb-5qoivag2KMclH4qeG5Q/#/search'>
                          <Button className='bookNowlink' style={{color:'#4d3319'}} to=''>BOOK NOW</Button>
                      </a>
                      </div>
                  </div>
              
              

            </div>
          
        </section>

        <div className='ligne'></div>

        <section data-Aos='fade-in' id="comfort" className='MovingCard'>
            <div className='room-list-wrapper'>
              
              
                  <div className='features-wrapper2'>
                      <div className='content-header'>
                      {/* <h6>From</h6> */}
                        
                        <h3 className='executive-header'>COMFORT DOUBLE</h3>
                        <p>04 well-appointed Comfort Rooms at the hotel, each equipped with top quality amenities and fixtures.</p>
                      </div>
                      <div  className='items-wrapper'>
                        <Row>
                          <Col lg={3} md={3} sm={3} xs={3} className='item-feature'>
                            <div className='item-feature-img'>
                              {/* <img  src={Tv} className='iconImg'  alt='feature-img' /> */}
                              <CgScreen  className='reactIcons' />
                            </div>
                            <div className='item-feature-content'>
                                <span> SMART TV</span>
                            </div>
                          </Col>
                          <Col lg={3} md={3} sm={3} xs={3} className='item-feature'>
                            <div className='item-feature-img'>
                              {/* <img src={Wifi} alt='feature-img' className='iconImg' /> */}
                              <AiOutlineWifi  className='reactIcons' />
                            </div>
                            <div className='item-feature-content'>
                                <span> High Speed Internet</span>
                            </div>
                          </Col>
                          <Col lg={3} md={3} sm={3} xs={3} className='item-feature'>
                            <div className='item-feature-img'>
                              {/* <img src={Iron} className='iconImg' alt='feature-img' /> */}
                              <BsSnow2  className='reactIcons' />
                            </div>
                            <div className='item-feature-content'>
                                <span> Air Conditioner</span>
                            </div>
                          </Col>
                          <Col lg={3} md={3} sm={3} xs={3} className='item-feature'>
                            <div className='item-feature-img'>
                            <GiDesk  className='reactIcons' />
                            </div>
                            <div className='item-feature-content'>
                                <span> Office Table</span>
                            </div>
                          </Col>
                        </Row>
                        <Row className='SecondRow'>
                          {/* <Col lg={3} md={3} sm={3} xs={3} className='item-feature'>
                            <div className='item-feature-img'>
                              <img src={SaveRoom} className='iconImg' alt='feature-img' />
                            </div>
                            <div className='item-feature-content'>
                                <span> Electronic In-room Safe</span>
                            </div>
                          </Col> */}
                          <Col lg={3} md={3} sm={3} xs={3} className='item-feature'>
                            <div className='item-feature-img'>
                              <MdOutlineKingBed  className='reactIcons' />
                            </div>
                            <div className='item-feature-content'>
                                <span> King Size Bed</span>
                            </div>
                          </Col>
                          <Col lg={3} md={3} sm={3} xs={3} className='item-feature'>
                            <div className='item-feature-img'>
                              {/* <img src={SaveRoom} className='iconImg' alt='feature-img' /> */}
                              <BiDish className='reactIcons' />
                            </div>
                            <div className='item-feature-content'>
                                <span> 24/7 Room Service</span>
                            </div>
                          </Col>
                          <Col lg={3} md={3} sm={3} xs={3} className='item-feature'>
                            <div className='item-feature-img'>
                              {/* <img src={SaveRoom} className='iconImg' alt='feature-img' /> */}
                              <IoResizeOutline  className='reactIcons' />
                            </div>
                            <div className='item-feature-content'>
                                <span> 240 ft2</span>
                            </div>
                          </Col>
                          
                        </Row>
                        
                          
                      </div>
                      <div className='readmoreClass'>
                        <Link  to='/deluxroom' style={{fontSize:'13px',color:'#4d3319'}}>READ MORE <IoIosArrowForward style={{verticalAlign:'text-bottom'}} /> </Link>
                      </div>
                      {/* <div className='priceRoom'>
                          <h6 style={{marginRight:'10px'}}>From</h6>
                          <h5><BiRupee />2499 /</h5>
                          <h6>per night*</h6>
                        </div> */}
                        <div className='wholeBox'>
                      <div className='priceBox'>
                          <div className='priceRoom'>
                            <h6 style={{marginRight:'10px'}}>From</h6>
                            <span className='lineBar'>
                                <h5><BiRupee />2499 /</h5>
                                <h6>per night*</h6>
                            </span>
                          
                          </div>

                          <div className='priceRoom2'>
                          
                            <h5><BiRupee />1649 /</h5>
                            <h6>per night*</h6>
                            {/* <p style={{color:'red',position:'relative',left:'10px',top:'-3px'}}>inclusive of all taxes - GST</p> */}
                          </div>
                            <p style={{color:'red',position:'relative',left:'70px',top:'-3px',fontFamily:'inherit'}}>inclusive of all taxes - GST</p>
                        </div>

                        <div className='bloc-discount'>
                          <img src={discount33} className='discount33' alt='logo' />
                        </div>
                        </div>
                      <div className='bookNow'>
                          <a href='https://www.secure-booking-engine.com/accounts/FrmOnne118jtpxNpFLSXTA/properties/hahnewYRURcxpWB0cjHizA/booking-engine/web/source/4wsctBw6Oq6j-g9XuxeRzQ/cart/Cb-5qoivag2KMclH4qeG5Q/#/search'>
                              <Button className='bookNowlink' style={{color:'#4d3319'}} to=''>BOOK NOW</Button>
                          </a>
                        
                      </div>
                  </div>
              
                  <NavLink to=''>
                  <Container  className='image-wrapper'>
                        <Link to='/deluxroom'>
                          <img src={comfort1} alt='tof' className='img-slide2 ' />
                        </Link>
                      
                      
                  </Container>
              </NavLink>

            </div>
          
        </section>
        
        {/* break line */}
                <div className='ligne'></div>

        <section data-Aos='fade-in' id='economic' className='MovingCard'>
            <div  className='room-list-wrapper'>
              <NavLink to=''>
                  <Container  className='image-wrapper'>
                        <Link to='/premiumroom'>
                          <img src={economic2} alt='tof' className='img-slide ' />
                        </Link>
                      
                      
                  </Container>
              </NavLink>
              
                  <div className='features-wrapper'>
                      <div className='content-header'>
                      
                        
                        <h3 className='executive-header'>ECONOMIC DOUBLE</h3>
                        <p>03 well-appointed Economic rooms at the hotel, each equipped with top quality amenities and fixtures.</p>
                      </div>
                      <div  className='items-wrapper'>
                      <Row>
                          <Col lg={3} md={3} sm={3} xs={3} className='item-feature'>
                            <div className='item-feature-img'>
                              
                              <CgScreen  className='reactIcons' />
                            </div>
                            <div className='item-feature-content'>
                                <span> SMART TV</span>
                            </div>
                          </Col>
                          <Col lg={3} md={3} sm={3} xs={3} className='item-feature'>
                            <div className='item-feature-img'>

                              <AiOutlineWifi  className='reactIcons' />
                            </div>
                            <div className='item-feature-content'>
                                <span> High Speed Internet</span>
                            </div>
                          </Col>
                          <Col lg={3} md={3} sm={3} xs={3} className='item-feature'>
                            <div className='item-feature-img'>
                              
                              <BsSnow2  className='reactIcons' />
                            </div>
                            <div className='item-feature-content'>
                                <span> Air Conditioner</span>
                            </div>
                          </Col>
                          <Col lg={3} md={3} sm={3} xs={3} className='item-feature'>
                            <div className='item-feature-img'>
                            <GiDesk  className='reactIcons' />
                            </div>
                            <div className='item-feature-content'>
                                <span> Office Table</span>
                            </div>
                          </Col>
                        </Row>
                        <Row className='SecondRow'>
                          {/* <Col lg={3} md={3} sm={3} xs={3} className='item-feature'>
                            <div className='item-feature-img'>
                              <img src={SaveRoom} className='iconImg' alt='feature-img' />
                            </div>
                            <div className='item-feature-content'>
                                <span> Electronic In-room Safe</span>
                            </div>
                          </Col> */}
                          <Col lg={3} md={3} sm={3} xs={3} className='item-feature'>
                            <div className='item-feature-img'>
                              <MdOutlineKingBed  className='reactIcons' />
                            </div>
                            <div className='item-feature-content'>
                                <span> Queen Size Bed</span>
                            </div>
                          </Col>
                          <Col lg={3} md={3} sm={3} xs={3} className='item-feature'>
                            <div className='item-feature-img'>
                              <BiDish  className='reactIcons' />
                            </div>
                            <div className='item-feature-content'>
                                <span> 24/7 Room Service</span>
                            </div>
                          </Col>
                          <Col lg={3} md={3} sm={3} xs={3} className='item-feature'>
                            <div className='item-feature-img'>
                              
                              <IoResizeOutline  className='reactIcons' />
                            </div>
                            <div className='item-feature-content'>
                                <span> 130 ft2</span>
                            </div>
                          </Col>
                          
                        </Row>
                        
                          
                      </div>
                      <div className='readmoreClass'>
                        <Link  to='/premiumroom' style={{fontSize:'13px',color:'#4d3319'}}>READ MORE <IoIosArrowForward style={{verticalAlign:'text-bottom'}} /> </Link>
                      </div>
                      {/* <div className='priceRoom'>
                          <h6 style={{marginRight:'10px'}}>From</h6>
                          <h5><BiRupee />1499 /</h5>
                          <h6>per night*</h6>
                        </div> */}
                        <div className='wholeBox'>
                      <div className='priceBox'>
                          <div className='priceRoom'>
                            <h6 style={{marginRight:'10px'}}>From</h6>
                            <span className='lineBar'>
                                <h5><BiRupee />1499 /</h5>
                                <h6>per night*</h6>
                            </span>
                          
                          </div>

                          <div className='priceRoom2'>
                          
                            <h5><BiRupee />999 /</h5>
                            <h6>per night*</h6>
                            {/* <p style={{color:'red',position:'relative',left:'10px',top:'-3px'}}>inclusive of all taxes - GST</p> */}
                          </div>
                            <p style={{color:'red',position:'relative',left:'70px',top:'-3px',fontFamily:'inherit'}}>inclusive of all taxes - GST</p>
                        </div>

                        <div className='bloc-discount'>
                          <img src={discount33} className='discount33' alt='logo' />
                        </div>
                        </div>
                      <div className='bookNow'>
                          <a href='https://www.secure-booking-engine.com/accounts/FrmOnne118jtpxNpFLSXTA/properties/hahnewYRURcxpWB0cjHizA/booking-engine/web/source/4wsctBw6Oq6j-g9XuxeRzQ/cart/Cb-5qoivag2KMclH4qeG5Q/#/search'>
                              <Button className='bookNowlink' style={{color:'#4d3319'}} to=''>BOOK NOW</Button>
                          </a>
                        
                      </div>
                  </div>
              
              

            </div>
          
        </section>

        <div className='ligne'></div>
        {/* Maharaj room */}

        <section data-Aos='fade-in' id="maharaja" className='MovingCard'>
            <div className='room-list-wrapper'>
              
              
                  <div className='features-wrapper2'>
                      <div className='content-header'>
                      {/* <h6>From</h6> */}
                        
                        <h3 className='executive-header'>MAHARAJA SUITE</h3>
                        <p>01 well-appointed Maharaja Suite Room at the hotel equipped with top quality amenities and fixtures.</p>
                      </div>
                      <div  className='items-wrapper'>
                        <Row>
                          <Col lg={3} md={3} sm={3} xs={3} className='item-feature'>
                            <div className='item-feature-img'>
                              {/* <img  src={Tv} className='iconImg'  alt='feature-img' /> */}
                              <CgScreen  className='reactIcons' />
                            </div>
                            <div className='item-feature-content'>
                                <span> SMART TV</span>
                            </div>
                          </Col>
                          <Col lg={3} md={3} sm={3} xs={3} className='item-feature'>
                            <div className='item-feature-img'>
                              {/* <img src={Wifi} alt='feature-img' className='iconImg' /> */}
                              <AiOutlineWifi  className='reactIcons' />
                            </div>
                            <div className='item-feature-content'>
                                <span> High Speed Internet</span>
                            </div>
                          </Col>
                          <Col lg={3} md={3} sm={3} xs={3} className='item-feature'>
                            <div className='item-feature-img'>
                              {/* <img src={Iron} className='iconImg' alt='feature-img' /> */}
                              <BsSnow2  className='reactIcons' />
                            </div>
                            <div className='item-feature-content'>
                                <span> Air Conditioner</span>
                            </div>
                          </Col>
                          <Col lg={3} md={3} sm={3} xs={3} className='item-feature'>
                            <div className='item-feature-img'>
                            <GiDesk  className='reactIcons' />
                            </div>
                            <div className='item-feature-content'>
                                <span> Office Table</span>
                            </div>
                          </Col>
                        </Row>
                        <Row className='SecondRow'>
                          {/* <Col lg={3} md={3} sm={3} xs={3} className='item-feature'>
                            <div className='item-feature-img'>
                              <img src={SaveRoom} className='iconImg' alt='feature-img' />
                            </div>
                            <div className='item-feature-content'>
                                <span> Electronic In-room Safe</span>
                            </div>
                          </Col> */}
                          <Col lg={3} md={3} sm={3} xs={3} className='item-feature'>
                            <div className='item-feature-img'>
                              <MdOutlineKingBed  className='reactIcons' />
                            </div>
                            <div className='item-feature-content'>
                                <span> California King Size Bed</span>
                            </div>
                          </Col>
                          <Col lg={3} md={3} sm={3} xs={3} className='item-feature'>
                            <div className='item-feature-img'>
                              {/* <img src={SaveRoom} className='iconImg' alt='feature-img' /> */}
                              <BiDish className='reactIcons' />
                            </div>
                            <div className='item-feature-content'>
                                <span> 24/7 Room Service</span>
                            </div>
                          </Col>
                          <Col lg={3} md={3} sm={3} xs={3} className='item-feature'>
                            <div className='item-feature-img'>
                              {/* <img src={SaveRoom} className='iconImg' alt='feature-img' /> */}
                              <IoResizeOutline  className='reactIcons' />
                            </div>
                            <div className='item-feature-content'>
                                <span> 360 ft2</span>
                            </div>
                          </Col>
                          
                        </Row>
                        
                          
                      </div>
                      <div className='readmoreClass'>
                        <Link  to='/maharajasuite' style={{fontSize:'13px',color:'#4d3319'}}>READ MORE <IoIosArrowForward style={{verticalAlign:'text-bottom'}} /> </Link>
                      </div>
                      <div className='wholeBox'>
                      <div className='priceBox'>
                          <div className='priceRoom'>
                            <h6 style={{marginRight:'10px'}}>From</h6>
                            <span className='lineBar'>
                                <h5><BiRupee />2999 /</h5>
                                <h6>per night*</h6>
                            </span>
                          
                          </div>

                          <div className='priceRoom2'>
                          
                            <h5><BiRupee />2009 /</h5>
                            <h6>per night*</h6>
                            {/* <p style={{color:'red',position:'relative',left:'10px',top:'-3px'}}>inclusive of all taxes - GST</p> */}
                          </div>
                            <p style={{color:'red',position:'relative',left:'70px',top:'-3px',fontFamily:'inherit'}}>inclusive of all taxes - GST</p>
                        </div>

                        <div className='bloc-discount'>
                          <img src={discount33} className='discount33' alt='logo' />
                        </div>
                        </div>
                      {/* <div className='priceRoom'>
                          <h6 style={{marginRight:'10px'}}>From</h6>
                          <h5><BiRupee />2999 /</h5>
                          <h6>per night*</h6>
                        </div> */}
                      <div className='bookNow'>
                        {/* <a   href='https://api.whatsapp.com/send?phone=919614385253'> */}
                        <a href='tel:918029901551'>
                          <Button style={{color:'#4d3319'}} className='bookNowlink'>Phone Bookings Only</Button>
                        </a>
                      </div>
                  </div>
              
                  <NavLink to=''>
                  <Container  className='image-wrapper'>
                    <Link to='/maharajasuite'>
                        <img src={Maharaja02} alt='tof' className='img-slide2 ' />
                    </Link>
                      
                      
                  </Container>
              </NavLink>

            </div>
          
        </section>




        <section className='MovingCard' style={{display:'none'}} >
            <div className='room-list-wrapper'>
              
              
                  <div className='features-wrapper2'>
                      <div className='content-header'>
                        <h3 className='executive-header'>CLASSIC ROOM</h3>
                        <p>7 well-appointed Classic Rooms at the hotel, each equipped with top quality amenities and fixtures.</p>
                      </div>
                      <div  className='items-wrapper'>
                        <Row>
                          <Col lg={3} md={3} sm={3} xs={3} className='item-feature'>
                            <div className='item-feature-img'>
                              <img  src={Tv} className='iconImg'  alt='feature-img' />
                            </div>
                            <div className='item-feature-content'>
                                <span> 42" LCD TV</span>
                            </div>
                          </Col>
                          <Col lg={3} md={3} sm={3} xs={3} className='item-feature'>
                            <div className='item-feature-img'>
                              <img src={Wifi} alt='feature-img' className='iconImg' />
                            </div>
                            <div className='item-feature-content'>
                                <span> High Speed Internet</span>
                            </div>
                          </Col>
                          {/* <Col lg={3} md={3} sm={3} xs={3} className='item-feature'>
                            <div className='item-feature-img'>
                              <img src={Iron} className='iconImg' alt='feature-img' />
                            </div>
                            <div className='item-feature-content'>
                                <span> Iron & Ironing Board</span>
                            </div>
                          </Col> */}
                          <Col lg={3} md={3} sm={3} xs={3} className='item-feature'>
                            <div className='item-feature-img'>
                              <img src={TeaMaker} className='iconImg' alt='feature-img' />
                            </div>
                            <div className='item-feature-content'>
                                <span> Tea / Coffee Maker</span>
                            </div>
                          </Col>
                        </Row>
                        <Row className='SecondRow'>
                          <Col lg={3} md={3} sm={3} xs={3} className='item-feature'>
                            <div className='item-feature-img'>
                              <img src={SaveRoom} className='iconImg' alt='feature-img' />
                            </div>
                            <div className='item-feature-content'>
                                <span> Electronic In-room Safe</span>
                            </div>
                          </Col>
                          {/* <Col lg={3} md={3} sm={3} xs={3} className='item-feature'>
                            <div className='item-feature-img'>
                              <img src={KingBed} className='iconImg' alt='feature-img' />
                            </div>
                            <div className='item-feature-content'>
                                <span> King Size Bed</span>
                            </div>
                          </Col> */}
                          {/* <Col lg={3} md={3} sm={3} xs={3} className='item-feature'>
                            <div className='item-feature-img'>
                              <img src={Telphone} className='iconImg' alt='feature-img' />
                            </div>
                            <div className='item-feature-content'>
                                <span> Telephone</span>
                            </div>
                          </Col> */}
                          
                        </Row>
                        
                          
                      </div>
                      <div className='readmoreClass'>
                        <NavLink  to='' style={{fontSize:'13px',color:'#4d3319'}}>READ MORE <IoIosArrowForward style={{verticalAlign:'text-bottom'}} /> </NavLink>
                      </div>
                      <div className='bookNow'>
                        <NavLink className='bookNowlink' style={{color:'#4d3319'}} to=''>BOOK NOW</NavLink>
                      </div>
                  </div>
              
                  <NavLink to=''>
                  <Container  className='image-wrapper'>
                      <img src={premiumRoom4} alt='tof' className='img-slide2 ' />
                      
                  </Container>
              </NavLink>

            </div>
          
        </section>


        

        <section id='lux1' className='Mobilecard'>
          <MobileCard bookUrl={'https://www.secure-booking-engine.com/accounts/FrmOnne118jtpxNpFLSXTA/properties/hahnewYRURcxpWB0cjHizA/booking-engine/web/source/4wsctBw6Oq6j-g9XuxeRzQ/cart/rvihAtgVBGGfltd7DzgEvQ/#/search'}
           photo={classic3} picLink={'/luxroom'}   header={'CLASSIC DOUBLE'} btnTitle={'BOOK NOW'} content={'07 well appointed Classic Size Rooms...'} address={'/luxroom'} oldPrice={'1999'} newPrice={'1319'}  />
        </section>
        <div className='ligne2'></div>
        <section id='delux1'  className='Mobilecard'>
          <MobileCard picLink={'/deluxroom'} bookUrl={'https://www.secure-booking-engine.com/accounts/FrmOnne118jtpxNpFLSXTA/properties/hahnewYRURcxpWB0cjHizA/booking-engine/web/source/4wsctBw6Oq6j-g9XuxeRzQ/cart/rvihAtgVBGGfltd7DzgEvQ/#/search'}
           address={'/deluxroom'} photo={comfort1} btnTitle={'BOOK NOW'}  header={'COMFORT DOUBLE'} oldPrice={'2499'} newPrice={'1649'} content={'04 well-appointed comfort Rooms at the hotel, each equipped with top quality amenities and fixtures.'} />
        </section>
        <div className='ligne2'></div>
        <section id='premium1'  className='Mobilecard'>
          <MobileCard picLink={'/premiumroom'} bookUrl={'https://www.secure-booking-engine.com/accounts/FrmOnne118jtpxNpFLSXTA/properties/hahnewYRURcxpWB0cjHizA/booking-engine/web/source/4wsctBw6Oq6j-g9XuxeRzQ/cart/rvihAtgVBGGfltd7DzgEvQ/#/search'}
           address={'/premiumroom'} photo={economic2} btnTitle={'BOOK NOW'}  header={'ECONOMIC DOUBLE'} oldPrice={'1499'} newPrice={'999'} content={'03 well-appointed Economic Rooms at the hotel, each equipped with top quality amenities and fixtures.'} />
        </section>
        <div className='ligne2'></div>
        <section id='delux1'  className='Mobilecard'>
          <MobileCard picLink={'/maharajasuite'} bookUrl={'tel:918029901551'}
           address={'/maharajasuite'} photo={Maharaja02} btnTitle={'Phone Bookings Only'}  header={'MAHARAJA SUITE'} oldPrice={'2999'} newPrice={'2009'} content={'01 well-appointed Maharaja Suite at the hotel equipped with top quality amenities and fixtures.'} />
        </section>
        
      </section>
      
      
      
     
  </div>
      
      
    )
}

export default DiscoverPage;
